var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jInput date-time-container" },
    [
      _c("vue-datetime", {
        staticClass: "jDatetime",
        attrs: {
          value: _vm.value,
          type: _vm.type,
          title: _vm.title,
          "min-datetime": _vm.minDatetime,
          "max-datetime": _vm.maxDatetime,
          auto: _vm.auto,
          "use12-hour": _vm.use12hour,
          phrases: _vm.phrases,
          "hour-step": _vm.hourStep,
          "minute-step": _vm.minuteStep,
          placeholder: _vm.placeholder,
          format: _vm.format,
          disabled: _vm.disabled,
          "value-zone": "UTC+7",
          "input-class": "jFormGroup form-control"
        },
        on: {
          input: function($event) {
            _vm.$emit("input", $event)
          }
        },
        model: {
          value: _vm.stringDate,
          callback: function($$v) {
            _vm.stringDate = $$v
          },
          expression: "stringDate"
        }
      }),
      _vm._v(" "),
      _vm.errorRequired
        ? _c("label", { staticClass: "show" }, [
            _vm._v(_vm._s(_vm.errorMessage) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isFilled && !_vm.disabled,
              expression: "isFilled && !disabled"
            }
          ],
          staticClass: "x-container date-time"
        },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/icon/xmark.svg"),
              alt: "Clear Value"
            },
            on: { click: _vm.clearValue }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10c55e0f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10c55e0f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/jDateTime.vue
// module id = null
// module chunks = 